module.exports = __webpack_public_path__ + "static/avatar-f5f31410eed534ccf35938feabd9f7b4.png";